import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { DeleteDialogContent } from './DeleteDialogContent'

interface IProps {
  showDialog: boolean
  onDelete: () => void
  onClose: () => void
}

export const DeleteDialog = ({ showDialog, onDelete, onClose }: IProps) => {
  const contentProps = useMemo(() => {
    return { onDelete, onClose }
  }, [onDelete, onClose])

  return (
    <ModalDialog
      size={'xs'}
      show={showDialog}
      content={DeleteDialogContent}
      contentProps={contentProps}
      onClose={onClose}
    />
  )
}
